export const API_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3333/spotlight';
export const AUTH_URL =
  import.meta.env.VITE_AUTH_URL || 'http://localhost:3002';
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || '';
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || '';
